import { get as getCookie } from "es-cookie";

import { extractTokenValue } from "./token";
import { User } from "./types";
import WebKeys from "./WebKeys";

/**
 * Recupera el token de usuario, si existe.
 */
export function getUserToken(): string | undefined {
  return getCookie(WebKeys.USER_TOKEN_COOKIE);
}

/**
 * Recupera el usuario de la sesión, si existe.
 */
export function getUser(): User | null {
  const userToken = getUserToken();

  return userToken != null ? extractTokenValue(userToken) : null;
}
